import _ from 'lodash'
import { Switch as cSwitch } from '@coreui/vue'
import { VclFacebook } from 'vue-content-loading';

// path, paramater 만 지원
export default {
  name: 'RuleMethod',
  props: ['origin', 'name', 'is_setup', 'example', 'origin_use_method', '_show_block_only', 'now_mode'],
  components : { cSwitch, VclFacebook },
  computed: {},
  watch: {
    origin() {
      // 기존 값이 변경시 해당 데이터 업데이트, 컴포넌트로 사용시 필요
      // this.load() // 뷰 순환 참조로 사용하지 못함
      this.method_list = this.filter(this.origin && this.origin.length ?  this.origin : this.method_list)
      this.use_method = !this.origin_use_method ? false : this.origin_use_method
      console.log('RuleMethod.vue', 'changed', this.origin_use_method,  '=>', this.use_method);
    },
  },
  data: () => {
    return {
      method_list : [
        { method : 'GET',  ip_list : "", is_block : false, is_mode : true, },
        { method : 'POST',  ip_list : "", is_block : false, is_mode : true, },
        { method : 'DELETE',  ip_list : "", is_block : false, is_mode : true, },
        { method : 'PATCH',  ip_list : "", is_block : false, is_mode : true, },
        { method : 'PUT',  ip_list : "", is_block : false, is_mode : true, },
        { method : 'OPTIONS',  ip_list : "", is_block : false, is_mode : true, },
      ],
      select_all : false,
      country : '',
      explain_modal :false,
      model : [],
      ex : '',
      use_method : false,
      loading : false
    }
  },
  methods: {
    filter(method_list) {
      let rv = method_list
      for (let i = 0; i < rv.length; i++) {
        rv[i].ip_list = typeof '' == typeof rv[i].ip_list ? rv[i].ip_list : rv[i].ip_list.join('\n')
      }
      return rv
    },
    change_use_method(val, x) {
      if(this.loading) {
        return console.log('loading is no updated', this.use_method, '=>', val)
      }
      console.log('WTF, use method toggle', val, this.use_method, x, new Date())
      this.use_method = val
      this.$parent.$emit('use_method', val) // 변경될 때마다 업데이트
    },
    refresh() {
      // some action here
      this.$parent.$emit("refresh")
    },
    load() {
      this.loading = true;
      console.log('RuleMethod.vue', 'load', this.origin.length, this.use_method, this.origin_use_method);
      this.method_list = this.filter(this.origin && this.origin.length ?  this.origin : this.method_list)
      this.use_method = !this.origin_use_method ? false : this.origin_use_method
      this.loading = false;
      this.$parent.$emit('update', this.method_list)
    },
    update($value, key, type) {
      console.log('RuleMethod.vue', 'update', $value, key, type);
      if(this.loading) {
        return console.log('loading is no updated', key, type)
      }
      this.method_list[_.findIndex(this.method_list, x => x.method == key)][type] = $value
      this.$parent.$emit('update', this.method_list)
      location.hostname == 'localhost' ? console.info('update RuleCustom => parent', $value, key) : ''
    },
  },
  created: function() { console.log('RuleMethod.vue', 'created'); },
  destroyed: function() { console.log('RuleMethod.vue', 'destroyed'); },
  mounted: function() { this.load() }
}
